import { Formik } from "formik";
import React, { useState, useEffect, useRef } from "react";
import * as yup from "yup";
import { Col, Form, Row, Spinner, Table } from "react-bootstrap";
import Fontstyling, {
  clientListDrpDwnStyles,
  tablestyle,
} from "../../../components/common/comman";
import Required from "../../../components/Required";
import {
  GetCGTMemberID,
  GetClientByCGTMemberID,
  GetICD10NCDCodeAndDescription,
  GetStates,
  InsertClinicalIntakeData,
} from "../../../api/ClinicalIntake/ClinicalIntakeApi";
import { useSelector } from "react-redux";
import { MdAddCircle, MdEditSquare, MdRemoveCircle } from "react-icons/md";
import { IoCheckmarkCircle } from "react-icons/io5";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import editIconWhite from "../../../assets/icon/pencil-fill-white.svg";
import deleteIcon from "../../../assets/icon/trash-solid.svg";
import deleteIconWhite from "../../../assets/icon/trash-solid-white.svg";
import { AsyncPaginate } from "react-select-async-paginate";
import { getClientsDatabyPaginationbySearch } from "../../../api/User/commonApi";
import moment from "moment";
import html2canvas from "html2canvas";
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ReactToPrint from "react-to-print";
import toastFile from "../../../Service/ToastFile";
import { FaRegCheckCircle } from "react-icons/fa";
import theme from "../../../Utils/theme";
import ReactTooltip from "react-tooltip";
import { useLocation } from "react-router";
import {
  GetClientByClientID,
  GetClientsDataByClientID,
} from "../../../api/User/ACG/clientDeatilApi";
const stepHeaders = [
  {
    id: 1,
    title: "Clinical Intake Form",
    description: "Clinical Intake and Reporting Form",
  },
  {
    id: 2,
    title: "Clinical Situation (S)",
    description:
      "Enter the clinical information associated with the Plan Insights Member diagnosis and affiliated",
  },
  {
    id: 3,
    title: "Background (B)",
    description:
      "Provide summary of findings based on reported claims in the observation period listed above",
  },
  {
    id: 4,
    title: "Assessment (A)",
    description:
      "Provide a summary of potential procedures, treatments, medications and outcomes associated with the member's claim profile",
  },
  {
    id: 5,
    title: "Recommendation (R)",
    description:
      "Provide recommendation related to plan policy, treatment review, stop loss, well-being, etc. This includes exploration of alternatives, site of care changes, white/brown bagging, forensic billing review, recovery/subrogation need, etc.",
  },
];

const SBARForm = () => {
  const user = useSelector((state) => state.userDetails.value);
  const divToPrintRef = useRef();
  const [step, setStep] = useState(1);
  const [form1Values, setForm1Values] = useState(null);
  const [form2Values, setForm2Values] = useState(null);
  const [form3Values, setForm3Values] = useState(null);
  const [form4Values, setForm4Values] = useState(null);
  const [form5Values, setForm5Values] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isPreveiw, setIsPreveiw] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    divToPrintRef.current && divToPrintRef.current.scrollIntoView();
  }, [step]);

  const submitClinicalIntakeData = () => {
    setIsLoading(true);
    let payload = {
      ...form1Values,
      ...form2Values,
      ...form3Values,
      ...form4Values,
      ...form5Values,
      createdBy: `${user.UD_emp_email}`,
    };
    // console.log({ payload });
    InsertClinicalIntakeData(payload)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsSubmitted(true);
          // console.log(res.data);
          setIsPreveiw(false);
          setStep(6);
          // toastFile(res.data, "success");
        } else {
          // console.log(res.data);
          toastFile(res?.response?.message, "error");
        }
      })
      .finally((res) => setIsLoading(false));
  };
  return (
    <>
      <div
        className={
          isPreveiw || isSubmitted ? "my-auto mx-5 pe-none" : "pe-auto"
        }
        ref={divToPrintRef}
      >
        <div
          className={
            isPreveiw || step === 1 ? "d-block form-section mt-3" : "d-none"
          }
        >
          <Form1
            step={step}
            setStep={setStep}
            setFormValues={setForm1Values}
            isPreveiw={isPreveiw}
          />
        </div>
        <div
          className={
            isPreveiw || step === 2 ? "d-block form-section mt-3" : "d-none"
          }
          // style={{ pageBreakBefore: "always" }}
        >
          <Form2
            step={step}
            setStep={setStep}
            setFormValues={setForm2Values}
            isPreveiw={isPreveiw}
          />
        </div>
        <div
          className={
            isPreveiw || step === 3 ? "d-block form-section mt-3" : "d-none"
          }
          style={{ pageBreakBefore: "always" }}
        >
          <Form3
            step={step}
            setStep={setStep}
            setFormValues={setForm3Values}
            isPreveiw={isPreveiw}
          />
        </div>
        <div
          className={
            isPreveiw || step === 4 ? "d-block form-section mt-3" : "d-none"
          }
          // style={{ pageBreakBefore: "always" }}
        >
          <Form4
            step={step}
            setStep={setStep}
            setFormValues={setForm4Values}
            isPreveiw={isPreveiw}
          />
        </div>
        <div
          className={
            isPreveiw || step === 5 ? "d-block form-section mt-3" : "d-none"
          }
          // style={{ pageBreakBefore: "always" }}
        >
          <Form5
            step={step}
            setStep={setStep}
            setFormValues={setForm5Values}
            isPreveiw={isPreveiw}
            setIsPreveiw={setIsPreveiw}
          />
        </div>
        <div
          className={isSubmitted || step === 6 ? "d-block" : "d-none"}
          // style={{ pageBreakBefore: "always" }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="mb-3">
              <FaRegCheckCircle
                size={"6vw"}
                color={theme.SECONDARY_SHOCKING_BLUE}
              />
            </div>
            <div style={{ ...Fontstyling.modalHeading, fontSize: "2.3vw" }}>
              Thank You!
            </div>
            <div style={{ ...Fontstyling.label, fontSize: "1vw" }}>
              SBAR form submitted successfully.
            </div>
          </div>
        </div>
      </div>

      {isPreveiw && !isSubmitted && (
        <div className="d-flex d-block align-items-center gap-3 mt-4 mx-5 pe-auto">
          <button
            style={Fontstyling.cancelbutton}
            type="button"
            onClick={() => setIsPreveiw(false)}
          >
            Back
          </button>{" "}
          <ReactToPrint
            trigger={() => (
              <button
                style={Fontstyling.savebutton}
                className="pe-auto"
                type="button"
              >
                Print
              </button>
            )}
            content={() => divToPrintRef.current}

            // onBeforePrint={()=>setIsPreveiw(false)}
          />
          <button
            style={Fontstyling.savebutton}
            type="button"
            onClick={() => submitClinicalIntakeData()}
          >
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="false"
                  style={{ marginRight: "5px" }}
                />
                <span>Submitting...</span>
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      )}
    </>
  );
};

export default SBARForm;

const Form1 = ({ step, setStep, setFormValues, isPreveiw }) => {
  const user = useSelector((state) => state.userDetails.value);
  const location = useLocation();
  const [clientData, setClientData] = useState([]);
  const [selectedClientvalue, setSelectedClientValue] = useState(null);
  const [populateData, setPopulateData] = useState({
    client: {},
    planmemberId: {},
  });
  const [cgtIdData, setCgtIdData] = useState([]);
  const [selectedCgtId, setSelectedCgtId] = useState(null);
  const schema = yup.object().shape({
    date_Submitted: yup.date().required("Please select date"),
    // clinical_Consultant_FirstName: yup
    //   .string()
    //   .required("Please enter the name"),
    // clinical_Consultant_LastName: yup.string().required("required"),
    // benefit_Point_ID: yup.string().required("Please enter Banifit Point ID"),
    client_Name: yup.string().required("Please select client name"),
    cgT_Member_ID: yup
      .string()
      .required("Please select Plan Insights Member ID"),
    // member_DOB: yup.date().required("Please select DOB"),
    // member_Gender: yup.string().required("Please select gender"),
    // member_State: yup.string().required("Please select state"),
    observation_Start_Date: yup
      .date()
      .required("Please select observation start date"),
    observation_End_Date: yup
      .date()
      .required("Please select observation end date"),
  });
  useEffect(() => {
    if (location?.state?.rowData) {
      setSelectedClientValue({
        label: location?.state?.rowData?.clientName,
        value: location?.state?.rowData?.clientId,
      });
      setSelectedCgtId({
        label: location?.state?.rowData?.cgT_Member_ID,
        value: location?.state?.rowData?.cgT_Member_ID,
      });
      autoPopulate();
    }
  }, []);

  const autoPopulate = async () => {
    const findClientRes = await GetClientByClientID(
      location?.state?.rowData?.clientId
    );
    let cgtResponse = await GetCGTMemberID(
      10,
      1,
      location?.state?.rowData?.cgT_Member_ID
    );
    let clientDataObj = findClientRes?.data;
    let cgtDataObj = cgtResponse?.data[0];
    setPopulateData((prev) => ({
      ...prev,
      client: clientDataObj,
      planmemberId: cgtDataObj,
    }));
  };

  const initialValues = {
    date_Submitted: moment().format("YYYY-MM-DD"),
    clinical_Consultant_FirstName: user.UD_emp_name.split(" ")[0],
    clinical_Consultant_LastName: user.UD_emp_name.split(" ")[1],
    benefit_Point_ID: populateData?.client
      ? populateData?.client?.Benefit_Point_ID
      : "",
    client_Name: location?.state ? location?.state?.rowData?.clientName : "",
    cgT_Member_ID: location?.state
      ? location?.state?.rowData?.cgT_Member_ID
      : "",
    member_DOB: populateData?.planmemberId
      ? populateData?.planmemberId?.DATE_OF_BIRTH?.split("T")[0]
      : "",
    member_Gender: populateData?.planmemberId
      ? populateData?.planmemberId?.SEX
      : "",
    member_State:
      populateData?.planmemberId &&
      typeof populateData?.planmemberId?.STATE !== "object"
        ? populateData?.planmemberId?.STATE
        : "NA",
    observation_Start_Date: "",
    observation_End_Date: "",
  };

  const onSubmit = (data) => {
    // console.log({ data });
    setFormValues(data);
    setStep(step + 1);
  };
  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    // console.log(searchQuery?.length, "searchQuery?.length");
    if (searchQuery.length > 3 || searchQuery?.length === 0) {
      try {
        let response = await getClientsDatabyPaginationbySearch(
          user.UD_id,
          page,
          searchQuery
        );
        const data = await response.data.clientsDataModelUDid;
        setClientData([...clientData, ...data]);
        const newOptions = data.map((port) => ({
          value: port.clientID,
          label: port.clientName,
        }));
        return {
          options: newOptions,
          hasMore: newOptions.length >= 1,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error("Error fetching data:", error);
        return {
          options: [],
          hasMore: false,
          additional: {
            page: page,
          },
        };
      }
    } else {
      return {
        options: [{ value: 0, label: "Please type at least 4 characters" }],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
  };

  const loadIdOptions = async (searchQuery, loadedOptions, { page }) => {
    // console.log(searchQuery?.length, "searchQuery?.length");
    if (searchQuery.length > 3 || searchQuery?.length === 0) {
      try {
        let response = await GetCGTMemberID(100, page, searchQuery);
        const data = await response.data;
        setCgtIdData([...cgtIdData, ...data]);
        const newOptions = data.map((port) => ({
          value: port.PATIENT_ID,
          label: port.PATIENT_ID,
        }));
        return {
          options: newOptions,
          hasMore: newOptions.length >= 1,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error("Error fetching data:", error);
        return {
          options: [],
          hasMore: false,
          additional: {
            page: page,
          },
        };
      }
    } else {
      return {
        options: [{ value: 0, label: "Please type at least 4 characters" }],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
  };

  return (
    <>
      <h3 style={Fontstyling.heading}>{stepHeaders[0].title}</h3>
      <p style={Fontstyling.primaryparagraph}>{stepHeaders[0].description}</p>
      <Formik
        enableReinitialize
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={initialValues}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          setFieldValue,
          setFieldError,
          touched,
          isValid,
          errors,
          resetForm,
        }) => (
          <Form onSubmit={handleSubmit}>
            {/* {console.log(errors.client_Name, values)} */}
            <Row className="mb-3">
              <Form.Group className="px-2" as={Col} xs={6} md={4}>
                <Form.Label style={Fontstyling.label}>
                  Date Submitted <Required />
                </Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="date_Submitted"
                  placeholder="Date"
                  value={values.date_Submitted}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={errors.date_Submitted && touched.date_Submitted}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.date_Submitted}
                </Form.Control.Feedback>
              </Form.Group>
              <Col xs={12} md={8} className="px-2">
                <Form.Label style={Fontstyling.label}>
                  Clinical Consultant
                </Form.Label>
                <Row className="gap-3">
                  <Form.Group as={Col}>
                    <Form.Control
                      disabled={!isPreveiw}
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="text"
                      placeholder="First Name"
                      name="clinical_Consultant_FirstName"
                      value={values.clinical_Consultant_FirstName}
                      onChange={handleChange}
                      isInvalid={
                        touched.clinical_Consultant_FirstName &&
                        errors.clinical_Consultant_FirstName
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.clinical_Consultant_FirstName}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Control
                      disabled={!isPreveiw}
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="text"
                      placeholder="Last Name"
                      name="clinical_Consultant_LastName"
                      value={values.clinical_Consultant_LastName}
                      onChange={handleChange}
                      isInvalid={
                        touched.clinical_Consultant_LastName &&
                        errors.clinical_Consultant_LastName
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.clinical_Consultant_LastName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
              </Col>
            </Row>
            <Row className="">
              {location?.state ? (
                <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                  <Form.Label style={Fontstyling.label}>
                    Plan Insights Member ID <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={Fontstyling.label}
                    type="text"
                    placeholder="Plan Insights Member ID"
                    name="cgT_Member_ID"
                    value={values.cgT_Member_ID}
                    disabled={true}
                    // onChange={handleChange}
                    // isInvalid={
                    //   touched.benefit_Point_ID && errors.benefit_Point_ID
                    // }
                  />
                  {/* <Form.Control.Feedback type="invalid">
                  {errors.benefit_Point_ID}
                </Form.Control.Feedback> */}
                </Form.Group>
              ) : (
                <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                  <Form.Label style={Fontstyling.label}>
                    Plan Insights Member ID
                    <Required />
                  </Form.Label>
                  <AsyncPaginate
                    id="5465f"
                    value={selectedCgtId || ""}
                    loadOptions={loadIdOptions}
                    name="cgT_Member_ID"
                    debounceTimeout={2500}
                    styles={{
                      ...clientListDrpDwnStyles,
                      control: (base) => ({
                        ...clientListDrpDwnStyles.control(base),
                        border: `1px solid ${
                          errors.cgT_Member_ID &&
                          touched.cgT_Member_ID &&
                          !values.cgT_Member_ID
                            ? "red"
                            : "lightgrey"
                        }`,
                      }),
                    }}
                    placeholder="Select Plan Insights Member ID"
                    onChange={async(option) => {
                      setFieldValue("cgT_Member_ID", option.label);
                      setSelectedCgtId(option);
                      const findedMember = cgtIdData.find(
                        (item) => item.PATIENT_ID === option.label
                      );
                      setFieldValue(
                        "member_DOB",
                        moment(findedMember?.DATE_OF_BIRTH).format("yyyy-MM-DD")
                      );
                      setFieldValue("member_Gender", findedMember?.SEX);
                      setFieldValue(
                        "member_State",
                        typeof findedMember?.STATE !== "object"
                          ? findedMember?.STATE
                          : "NA"
                      );
                      let res = await GetClientByCGTMemberID(option.label);
                      if (res) {
                        if(res.data[0]?.CLIENTID){
                          const findClientRes = await GetClientByClientID(
                            res.data[0]?.CLIENTID
                          );
                          if(res.data.length > 0){
                            setFieldValue("client_Name", res.data[0]?.CLIENTNAME);
                            setFieldValue(
                              "benefit_Point_ID",
                              findClientRes?.data?.Benefit_Point_ID
                            );
                            setSelectedClientValue({label: res.data[0]?.CLIENTNAME,
                              value: res.data[0]?.CLIENTID})
                          }else{
                            setSelectedClientValue(null)
                            setFieldValue(
                              "benefit_Point_ID",
                              0
                            );
                          }
                        }
                      }
                    }}
                    additional={{
                      page: 1,
                    }}
                    isSearchable={true}
                    isOptionDisabled={(e) => e.value === 0}
                  />
                  {errors.cgT_Member_ID &&
                    touched.cgT_Member_ID &&
                    !values.cgT_Member_ID && (
                      <p className="invalid-feedback d-block">
                        {errors.cgT_Member_ID}
                      </p>
                    )}
                </Form.Group>
              )}
              {/* <Form.Group className="px-2 mb-3" as={Col} xs={6} lg>
                <Form.Label style={Fontstyling.label}>
                 Plan Insights Member ID <Required />
                </Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  placeholder="e.g.,23"
                  name="cgT_Member_ID"
                  value={values.cgT_Member_ID}
                  onChange={handleChange}
                  isInvalid={touched.cgT_Member_ID && errors.cgT_Member_ID}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.cgT_Member_ID}
                </Form.Control.Feedback>
              </Form.Group> */}
              <Form.Group className="px-2 mb-3" as={Col} xs={6} lg>
                <Form.Label style={Fontstyling.label}>Member DOB</Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="member_DOB"
                  placeholder="Authorized User"
                  value={values.member_DOB}
                  // onChange={handleChange}
                  // onBlur={handleBlur}
                  // isInvalid={errors.member_DOB && touched.member_DOB}
                  disabled={!isPreveiw}
                />
                {/* <Form.Control.Feedback type="invalid">
                  {errors.member_DOB}
                </Form.Control.Feedback> */}
              </Form.Group>
              <Form.Group className="px-2 mb-3" as={Col} xs={12} md={6} lg>
                <Form.Label style={Fontstyling.label}>Member Gender</Form.Label>
                <div className="d-flex align-items-center gap-3 ">
                  {["Male", "Female", "Other"].map((item) => (
                    <Form.Check
                      className="gap-2 text-dark"
                      type="radio"
                      value={values.member_Gender}
                      name="member_Gender"
                      readOnly
                      label={
                        <span
                          style={{
                            fontSize: 12,
                            letterSpacing: 0.2,
                            color: "#212529",
                          }}
                        >
                          {item}
                        </span>
                      }
                      onChange={handleChange}
                      checked={values.member_Gender === item[0]}
                      isInvalid={errors.member_Gender && touched.member_Gender}
                    />
                  ))}
                </div>
                {/* {errors.member_Gender && (
                  <p className="invalid-feedback d-block">
                    {errors.member_Gender}
                  </p>
                )} */}
              </Form.Group>
              <Form.Group className="px-2 mb-3" as={Col} xs={6} lg>
                <Form.Label style={Fontstyling.label}>Member State</Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  // placeholder="State"
                  name="member_State"
                  value={values.member_State}
                  disabled={!isPreveiw}
                  // onChange={handleChange}
                  // isInvalid={touched.member_State && errors.member_State}
                />
                {/* <Form.Control.Feedback type="invalid">
                  {errors.member_State}
                </Form.Control.Feedback> */}
              </Form.Group>
            </Row>
            <Row className="mb-3">
              {console.log({selectedClientvalue})}
              {(location?.state || selectedClientvalue !== null )? (
                 <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                  <Form.Label style={Fontstyling.label}>
                    Client Name <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={Fontstyling.label}
                    type="text"
                    placeholder="Client Name "
                    name="client_Name"
                    value={values.client_Name}
                    disabled={true}
                  />
                </Form.Group>)
                :
               ( <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                  <Form.Label style={Fontstyling.label}>
                    Client Name <Required />
                  </Form.Label>
                  <AsyncPaginate
                    value={selectedClientvalue || ""}
                    loadOptions={loadOptions}
                    debounceTimeout={2500}
                    styles={{
                      ...clientListDrpDwnStyles,
                      control: (base) => ({
                        ...clientListDrpDwnStyles.control(base),
                        border: `1px solid ${
                          errors.client_Name &&
                          touched.client_Name &&
                          !values.client_Name
                            ? "red"
                            : "lightgrey"
                        }`,
                      }),
                    }}
                    placeholder="Select Client name"
                    onChange={async (option) => {
                      const findClient = clientData.find(
                        (item) => item.clientID === option.value
                      );
                      setFieldValue("client_Name", option.label);
                      setFieldValue(
                        "benefit_Point_ID",
                        findClient?.benefit_Point_ID
                      );
                      setSelectedClientValue(option);
                    }}
                    additional={{
                      page: 1,
                    }}
                    isSearchable={true}
                    isOptionDisabled={(e) => e.value === 0}
                  />
                  {errors.client_Name &&
                    touched.client_Name &&
                    !values.client_Name && (
                      <p className="invalid-feedback d-block">
                        {errors.client_Name}
                      </p>
                    )}
                </Form.Group>)
            }
              <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                <Form.Label style={Fontstyling.label}>
                  Benefit Point ID
                </Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  placeholder="0"
                  name="benefit_Point_ID"
                  value={values.benefit_Point_ID}
                  disabled={!isPreveiw}
                  // onChange={handleChange}
                  // isInvalid={
                  //   touched.benefit_Point_ID && errors.benefit_Point_ID
                  // }
                />
                {/* <Form.Control.Feedback type="invalid">
                  {errors.benefit_Point_ID}
                </Form.Control.Feedback> */}
              </Form.Group>
              {/* <Form.Group as={Col} xs={4}>
              <Form.Label style={Fontstyling.label}>
                Client Name <Required />
              </Form.Label>
              <Form.Control
                className="rounded-0 py-1"
                style={Fontstyling.label}
                type="text"
                placeholder="e.g.,23"
                name="client_Name"
                value={values.client_Name}
                onChange={handleChange}
                isInvalid={touched.client_Name && errors.client_Name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.client_Name}
              </Form.Control.Feedback>
            </Form.Group> */}
            </Row>
            <Row className="mb-3">
              <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                <Form.Label style={Fontstyling.label}>
                  Observation Start Date <Required />
                </Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="observation_Start_Date"
                  placeoholder="Authorized User"
                  value={values.observation_Start_Date}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={
                    errors.observation_Start_Date &&
                    touched.observation_Start_Date
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.observation_Start_Date}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                <Form.Label style={Fontstyling.label}>
                  Observation End Date <Required />
                </Form.Label>
                <img
                  data-tip="Select start date first"
                  src={require("../../../assets/icon/Question_mark_back.png")}
                  style={{ height: 12, marginLeft: 3 }}
                />
                <ReactTooltip />
                <Form.Control
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="observation_End_Date"
                  placeholder="Authorized User"
                  value={values.observation_End_Date}
                  min={values.observation_Start_Date}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={values.observation_Start_Date ? false : true}
                  isInvalid={
                    errors.observation_End_Date && touched.observation_End_Date
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.observation_End_Date}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            {!isPreveiw && (
              <div className="d-flex align-items-center gap-3 mt-4">
                <button style={Fontstyling.savebutton} type="submit">
                  Next
                </button>
              </div>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};
const Form2 = ({ step, setStep, setFormValues, isPreveiw }) => {
  const schema = yup.object().shape({
    is_ICD10_NDC: yup
      .string()
      .notOneOf(["Select One"], "Please select one.")
      .required("Please select one."),
    icD10_NDC_Code: yup.string().required("Please select ICD-10 / NDC Code."),
    icD10_NDC_Description: yup.string().required("Please enter description."),
    first_Date_of_Service: yup
      .date()
      .required("Please select first date of service."),
    last_Date_of_Service: yup
      .date()
      .required("Please select last date of service."),
  });
  const initialValues = {
    is_ICD10_NDC: "",
    icD10_NDC_Code: "",
    icD10_NDC_Description: "",
    first_Date_of_Service: "",
    last_Date_of_Service: "",
  };
  const [selectedICDNCCode, setSelectedICDNCCode] = useState("");
  const [isManual, setIsManual] = useState(true);
  const inpRef = useRef(null);
  const onSubmit = (data) => {
    // console.log({ data });
    setFormValues(data);
    setStep(step + 1);
  };
  const getICD10NDCData = async (searchQuery, loadedOptions, { page }) => {
    // console.log(searchQuery,/^\d+$/.test(searchQuery));
    // const numberRegex = /^\d+$/;
    // if (!numberRegex.test(searchQuery) && searchQuery?.length !== 0) {
    //   return {
    //     options: [{ value: 0, label: "Please enter a number to search" }],
    //     hasMore: false,
    //     additional: {
    //       page: page,
    //     },
    //   };
    // }
    // if (searchQuery.length > 3 || searchQuery?.length === 0) {
    try {
      let response = await GetICD10NCDCodeAndDescription(20, page, searchQuery);
      const data = await response.data;
      const newOptions = data?.map((port) => ({
        label: port.ICD_NDC_CODE,
        value: port.ICD_NDC_DESCRIPTION,
      }));
      return {
        options: newOptions,
        hasMore: newOptions.length >= 1,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      console.error("Error fetching data:", error);
      return {
        options: [],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
    // } else {
    //   return {
    //     options: [{ value: 0, label: "Please type at least 4 characters" }],
    //     hasMore: false,
    //     additional: {
    //       page: page,
    //     },
    //   };
    // }
  };

  return (
    <>
      <h3 style={Fontstyling.heading}>{stepHeaders[1].title}</h3>
      <p style={Fontstyling.primaryparagraph}>{stepHeaders[1].description}</p>
      <Formik
        enableReinitialize
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={initialValues}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          setFieldValue,
          setFieldError,
          touched,
          isValid,
          errors,
          resetForm,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Row>
              <Form.Group as={Col} className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  ICD-10 or NDC <Required />
                </Form.Label>
                <Form.Select
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  name="is_ICD10_NDC"
                  value={values.is_ICD10_NDC}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={errors.is_ICD10_NDC && touched.is_ICD10_NDC}
                >
                  {["Select One", "ICD-10", "NDC"].map((opt, ind) => (
                    <option key={ind} value={opt}>
                      {opt}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.is_ICD10_NDC}
                </Form.Control.Feedback>
              </Form.Group>
              {/* <Form.Group as={Col}  className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  ICD-10 / NDC Code <Required />
                </Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  placeholder="e.g.,23"
                  name="icD10_NDC_Code"
                  value={values.icD10_NDC_Code}
                  onChange={handleChange}
                  isInvalid={touched.icD10_NDC_Code && errors.icD10_NDC_Code}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.icD10_NDC_Code}
                </Form.Control.Feedback>
              </Form.Group> */}
              <Form.Group as={Col} className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  ICD-10 / NDC Code <Required />
                </Form.Label>
                <AsyncPaginate
                  value={selectedICDNCCode || ""}
                  loadOptions={getICD10NDCData}
                  debounceTimeout={2500}
                  noOptionsMessage={({ inputValue }) => (
                    <button
                      className="btn btn-primary py-1 rounded-0 w-100 fw-bold"
                      style={Fontstyling.primaryparagraph}
                      onClick={async (e) => {
                        e.preventDefault();
                        await setIsManual(false);
                        setFieldValue("icD10_NDC_Description", "");
                        setFieldValue("icD10_NDC_Code", inputValue);
                        setSelectedICDNCCode({
                          label: inputValue,
                          value: inputValue,
                        });
                        inpRef.current.focus();
                      }}
                    >
                      Create New
                    </button>
                  )}
                  styles={{
                    ...clientListDrpDwnStyles,
                    control: (base) => ({
                      ...clientListDrpDwnStyles.control(base),
                      border: `1px solid ${
                        values.icD10_NDC_Code === "" && touched.icD10_NDC_Code
                          ? "red"
                          : "lightgrey"
                      }`,
                    }),
                  }}
                  placeholder="Select ICD10/NDC code"
                  onChange={(option) => {
                    // setSelectedICDNCCode({
                    //   label: option.value,
                    //   value: option.label,
                    // });
                    setIsManual(true);
                    setFieldError("icD10_NDC_Code", null);
                    setSelectedICDNCCode(option);
                    setFieldValue("icD10_NDC_Code", option.label);
                    setFieldValue("icD10_NDC_Description", option.value);
                  }}
                  additional={{
                    page: 1,
                  }}
                  isSearchable={true}
                  isOptionDisabled={(e) => e.value === 0}
                />
                {values.icD10_NDC_Code === "" && touched.icD10_NDC_Code && (
                  <p className="invalid-feedback d-block">
                    {errors.icD10_NDC_Code}
                  </p>
                )}
              </Form.Group>
              {/* <Form.Group as={Col} className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  ICD-10 / NDC Code <Required />
                </Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label }}
                  type="text"
                  name="icD10_NDC_Code"
                  placeholder="ICD-10 / NDC Code"
                  value={values.icD10_NDC_Code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={errors.icD10_NDC_Code && touched.icD10_NDC_Code}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.icD10_NDC_Code}
                </Form.Control.Feedback>
              </Form.Group> */}
              <Form.Group as={Col} className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  ICD-10 / NDC Description
                </Form.Label>
                <Form.Control
                  ref={inpRef}
                  // disabled={isManual}
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  placeholder="e.g.,23"
                  name="icD10_NDC_Description"
                  value={values.icD10_NDC_Description}
                  onChange={handleChange}
                  isInvalid={
                    touched.icD10_NDC_Description &&
                    errors.icD10_NDC_Description
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.icD10_NDC_Description}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} xs={6} lg={4} className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  First Date of Service <Required />
                </Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="first_Date_of_Service"
                  placeholder="Authorized User"
                  value={values.first_Date_of_Service}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={
                    errors.first_Date_of_Service &&
                    touched.first_Date_of_Service
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.first_Date_of_Service}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} xs={6} lg={4} className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  Last Date of Service <Required />
                </Form.Label>
                <img
                  data-tip="Select start date first"
                  src={require("../../../assets/icon/Question_mark_back.png")}
                  style={{ height: 12, marginLeft: 3 }}
                />
                <ReactTooltip />
                <Form.Control
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="last_Date_of_Service"
                  placeholder="Authorized User"
                  value={values.last_Date_of_Service}
                  min={values.first_Date_of_Service}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={values.first_Date_of_Service ? false : true}
                  isInvalid={
                    errors.last_Date_of_Service && touched.last_Date_of_Service
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.last_Date_of_Service}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            {!isPreveiw && (
              <div className="d-flex align-items-center gap-3 mt-4">
                <button
                  type="button"
                  style={Fontstyling.cancelbutton}
                  onClick={() => setStep(step - 1)}
                >
                  Previous
                </button>
                <button style={Fontstyling.savebutton} type="submit">
                  Next
                </button>
              </div>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};
const Form3 = ({ step, setStep, setFormValues, isPreveiw }) => {
  const initialValues = {
    clinical_Overview_Member_Claim_History: "",
  };
  const [tableData, setTableData] = useState([]);
  const inpRef = useRef(null);

  const onSubmit = (data) => {
    // console.log({ data });
    setFormValues({
      ...data,
      medication_Drug_Use: JSON.stringify([...tableData]),
    });
    setStep(step + 1);
  };
  const onRowDataSubmit = (values, handlers, rowInd, rowID) => {
    // console.log({ values, rowID, rowInd });
    // console.log({ values, handlers, rowInd, rowID });
    let radio = values[`radio${rowInd}`];
    const id =
      parseInt(new Date().toISOString().replace(/[-:.TZ]/g, "")) % 100000000;
    // console.log(id);

    let updatedRow = {
      id: rowID ?? id,
      ...values,
      OrphanDrug: radio === "OrphanDrug",
      OffLabel: radio === "OffLabel",
      ExpInvUse: radio === "ExpInvUse",
    };
    delete updatedRow[`radio${rowInd}`];

    if (rowID) {
      // console.log({ rowID });
      let data = [...tableData];
      let upd_row_ind = data.findIndex((r) => r.id === rowID);
      data.splice(upd_row_ind, 1, { ...updatedRow });
      // console.log([...data]);
      setTableData([...data]);
    } else {
      setTableData([...tableData, { ...updatedRow }]);
      // console.log([...tableData, { ...updatedRow }]);
    }
  };
  const onRowDelete = (id) => {
    // console.log({ id });
    let data = [...tableData];
    let dlt_row = data.findIndex((r) => r.id === id);
    // console.log({ dlt_row });
    data.splice(dlt_row, 1);
    setTableData([...data]);
    // console.log([...data]);
  };

  return (
    <>
      <h3 style={Fontstyling.heading}>{stepHeaders[2].title}</h3>
      <p style={Fontstyling.primaryparagraph}>{stepHeaders[2].description}</p>
      <Formik
        enableReinitialize
        // validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={initialValues}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          resetForm,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group className="mb-3">
                <Form.Label style={Fontstyling.label}>
                  Clinical Overview of Member Claim History:
                </Form.Label>
                <Form.Control
                  as="textarea"
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  name="clinical_Overview_Member_Claim_History"
                  onChange={handleChange}
                  value={values.clinical_Overview_Member_Claim_History}
                  rows={3}
                />
              </Form.Group>
              <Form.Label className="mt-2" style={Fontstyling.label}>
                Encounters or Notable Procedures (CPT / HCPCS) or Medication /
                Drug Use
              </Form.Label>
              <Table bordered hover responsive>
                <thead style={Fontstyling.label}>
                  <tr className="text-center align-middle">
                    {[
                      "",
                      "Typical for Dx / Rx",
                      "Atypical for Dx Rx",
                      "Staged",
                      "Orphan Drug",
                      "Off-Label",
                      "Exp/Inv Use",
                      "Actions",
                    ].map((el, ind) => {
                      if (isPreveiw && el === "Actions") return;
                      return <th key={ind}>{el}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {[...tableData, {}].map((row, rowInd) => (
                    <Form3TableRow
                      key={rowInd}
                      row={row}
                      rowInd={rowInd}
                      tableData={tableData}
                      onRowDataSubmit={onRowDataSubmit}
                      onRowDelete={onRowDelete}
                      step={step}
                      isPreveiw={isPreveiw}
                      inpRef={inpRef}
                    />
                  ))}
                </tbody>
              </Table>
            </Row>
            {!isPreveiw && (
              <div className="d-flex align-items-center gap-3 mt-4">
                <button
                  type="button"
                  style={Fontstyling.cancelbutton}
                  onClick={() => setStep(step - 1)}
                >
                  Previous
                </button>
                <button
                  style={Fontstyling.savebutton}
                  type="submit"
                  onClick={() => {
                    const addbtn = document.getElementById("tableform1");
                    if (inpRef.current.value) {
                      addbtn.click();
                    }
                  }}
                >
                  Next
                </button>
              </div>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};
const Form4 = ({ step, setStep, setFormValues, isPreveiw }) => {
  const schema = yup.object().shape({});
  const initialValues = {
    treatment_Description: "",
    potential_Complications: "",
    clinical_Consultant_Summary: "",
    reference_Links: "",
  };

  const [analyticsMedTblData, setAnalyticsMedTblData] = useState([]);
  const [analyticsRxTblData, setAnalyticsRxTblData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const inpRef1 = useRef(null);
  const inpRef2 = useRef(null);

  useEffect(() => {
    GetStates().then((res) => {
      setStateData(() =>
        res.data.sort((a, b) => a.state.localeCompare(b.state))
      );
    });
  }, []);

  const onSubmit = (data) => {
    // console.log({ data });
    setFormValues({
      ...data,
      treatment_Analytics_Medical: JSON.stringify([...analyticsMedTblData]),
      treatment_Analytics_Rx: JSON.stringify([...analyticsRxTblData]),
    });
    setStep(step + 1);
  };

  const onRowDataSubmit = (values, handlers, rowID, tblType) => {
    const id =
      parseInt(new Date().toISOString().replace(/[-:.TZ]/g, "")) % 100000000;
    // console.log({ values });
    let updatedRow = {
      id: rowID ?? id,
      ...values,
    };

    if (rowID) {
      // console.log({ rowID });
      let data =
        tblType === "TAMed"
          ? [...analyticsMedTblData]
          : [...analyticsRxTblData];
      let upd_row_ind = data.findIndex((r) => r.id === rowID);
      data.splice(upd_row_ind, 1, { ...updatedRow });

      if (tblType === "TAMed") {
        setAnalyticsMedTblData([...data]);
      } else {
        setAnalyticsRxTblData([...data]);
      }
    } else {
      if (tblType === "TAMed") {
        setAnalyticsMedTblData([...analyticsMedTblData, { ...updatedRow }]);
      } else {
        setAnalyticsRxTblData([...analyticsRxTblData, { ...updatedRow }]);
      }
    }
  };
  const onRowDelete = (id, tblType) => {
    // console.log({ id });
    let data =
      tblType === "TAMed" ? [...analyticsMedTblData] : [...analyticsRxTblData];
    let dlt_row = data.findIndex((r) => r.id === id);
    data.splice(dlt_row, 1);
    if (tblType === "TAMed") {
      setAnalyticsMedTblData([...data]);
    } else {
      setAnalyticsRxTblData([...data]);
    }
  };

  return (
    <>
      <h3 style={Fontstyling.heading}>{stepHeaders[3].title}</h3>
      <p style={Fontstyling.primaryparagraph}>{stepHeaders[3].description}</p>
      <Formik
        enableReinitialize
        // validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={initialValues}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          resetForm,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>
                Treatment Description / FDA Approved Indications:
              </Form.Label>
              <Form.Control
                as="textarea"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                name="treatment_Description"
                rows={3}
                onChange={handleChange}
                value={values.treatment_Description}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label style={Fontstyling.label}>
                Treatment Analytics Medical:
              </Form.Label>
              <Table bordered hover responsive>
                <thead style={Fontstyling.label}>
                  <tr className="text-center align-middle">
                    {[
                      "",
                      "State",
                      "Observation Cost",
                      "Billed Min",
                      "Billed Max",
                      "Nat'l Min",
                      "Nat'l Max",
                      "Actions",
                    ].map((el, ind) => {
                      if (isPreveiw && el === "Actions") return;
                      return <th key={ind}>{el}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {[...analyticsMedTblData, {}].map((row, rowInd) => (
                    <Form4TAMedTableRow
                      key={rowInd}
                      row={row}
                      rowInd={rowInd}
                      tableData={analyticsMedTblData}
                      onRowDataSubmit={onRowDataSubmit}
                      onRowDelete={onRowDelete}
                      step={step}
                      isPreveiw={isPreveiw}
                      stateData={stateData}
                      inpRef1={inpRef1}
                    />
                  ))}
                </tbody>
              </Table>
            </Form.Group>
            <Form.Group>
              <Form.Label style={Fontstyling.label}>
                Treatment Analytics Rx:
              </Form.Label>
              <Table bordered hover responsive>
                <thead style={Fontstyling.label}>
                  <tr className="text-center align-middle">
                    {[
                      "",
                      "Member Type",
                      "Line of Therapy",
                      "Qty Cost Basis",
                      "Observation Cost",
                      "AMS Risk Threshold",
                      "Cost Projection",
                      "Trigger Dx Name",
                      "Actions",
                    ].map((el, ind) => {
                      if (isPreveiw && el === "Actions") return;
                      return (
                        <th
                          style={{
                            width: `${100 / 8}%`,
                            minWidth: `${100 / 8}%`,
                            maxWidth: `${100 / 8}%`,
                          }}
                          key={ind}
                        >
                          {el}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {[...analyticsRxTblData, {}].map((row, rowInd) => (
                    <Form4TARxTableRow
                      key={rowInd}
                      row={row}
                      rowInd={rowInd}
                      tableData={analyticsRxTblData}
                      onRowDataSubmit={onRowDataSubmit}
                      onRowDelete={onRowDelete}
                      step={step}
                      isPreveiw={isPreveiw}
                      inpRef2={inpRef2}
                    />
                  ))}
                </tbody>
              </Table>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>
                Potential Complications:
              </Form.Label>
              <Form.Control
                as="textarea"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                name="potential_Complications"
                rows={3}
                onChange={handleChange}
                value={values.potential_Complications}
              />
              <p className="fw-normal" style={Fontstyling.primaryparagraph}>
                Using AMS criteria and/or criteria based on your license scope
                of practice, provide complications that may arise within this
                diagnosis, future treatments or medication use
              </p>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>
                Clinical Consultant Summary:
              </Form.Label>
              <Form.Control
                as="textarea"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                name="clinical_Consultant_Summary"
                rows={3}
                onChange={handleChange}
                value={values.clinical_Consultant_Summary}
              />
              <p className="fw-normal" style={Fontstyling.primaryparagraph}>
                Enter your final assessment of risk, expected cost, prognosis,
                and/or expected outcomes. Please be sure to reference sources
                that fall outside the scope of your licensure or sources used to
                complete your summary below.
              </p>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>
                Reference Links / Sources:
              </Form.Label>
              <Form.Control
                as="textarea"
                name="reference_Links"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                rows={3}
                onChange={handleChange}
                value={values.reference_Links}
              />
              <p className="fw-normal" style={Fontstyling.primaryparagraph}>
                If using a source other than AMS, provide source in APA format.
                Format links using https://citefast.com/?s=APA7
              </p>
            </Form.Group>
            {!isPreveiw && (
              <div className="d-flex  align-items-center gap-3 mt-4">
                <button
                  type="button"
                  style={Fontstyling.cancelbutton}
                  onClick={() => setStep(step - 1)}
                >
                  Previous
                </button>
                <button
                  style={Fontstyling.savebutton}
                  type="submit"
                  onClick={() => {
                    const addbtn1 = document.getElementById("tableform2");
                    const addbtn2 = document.getElementById("tableform3");
                    if (inpRef1.current?.value) {
                      addbtn1.click();
                    }
                    if (inpRef2.current?.value) {
                      addbtn2.click();
                    }
                  }}
                >
                  Next
                </button>
              </div>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};
const Form5 = ({ step, setStep, setFormValues, isPreveiw, setIsPreveiw }) => {
  const schema = yup.object().shape({});
  const initialValues = {
    clinical_Prognosis: "",
    clinical_Recommendations: "",
  };
  const onSubmit = (data) => {
    // console.log({ data });
    setFormValues(data);
    setIsPreveiw(true);
  };
  return (
    <>
      <h3 style={Fontstyling.heading}>{stepHeaders[4].title}</h3>
      <p style={Fontstyling.primaryparagraph}>{stepHeaders[4].description}</p>
      <Formik
        enableReinitialize
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={initialValues}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          resetForm,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>
                Clinical Prognosis:
              </Form.Label>
              <Form.Control
                as="textarea"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                rows={3}
                name="clinical_Prognosis"
                value={values.clinical_Prognosis}
                onChange={handleChange}
              />
              <p className="fw-normal" style={Fontstyling.primaryparagraph}>
                Enter prognosis based on research data, sources, and body of
                knowledge related to the diagnosis, treatment, medication, etc.
                Please be sure to use referenced sources if the recommendation
                or prognosis falls outside the scope of your licensure.
              </p>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>
                Clinical Recommendations:
              </Form.Label>
              <Form.Control
                as="textarea"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                rows={3}
                name="clinical_Recommendations"
                value={values.clinical_Recommendations}
                onChange={handleChange}
              />
              <p className="fw-normal" style={Fontstyling.primaryparagraph}>
                Enter clinical recommendations based on research data, sources,
                and body of knowledge related to the diagnosis, treatment,
                medication, etc. Please be sure to use referenced sources if the
                recommendation or prognosis falls outside the scope of your
                licensure.
              </p>
            </Form.Group>
            {!isPreveiw && (
              <div className="d-flex align-items-center gap-3 mt-4">
                <button
                  type="button"
                  style={Fontstyling.cancelbutton}
                  onClick={() => setStep(step - 1)}
                >
                  Previous
                </button>
                <button style={Fontstyling.savebutton} type="submit">
                  Preview & Submit
                </button>
              </div>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};

const Form3TableRow = ({
  row,
  rowInd,
  tableData,
  onRowDataSubmit,
  onRowDelete,
  step,
  isPreveiw,
  inpRef,
}) => {
  const isBlankRow = rowInd === tableData.length;
  const tblSchema = yup.object().shape({
    medic_drug_name: yup
      .string()
      .trim("The contact name cannot include leading and trailing spaces")
      .required("required"),
    // TypicalDxRx: yup
    //   .boolean()
    //   .oneOf([true])
    //   .required("required"),
    // AtypicalDxRx: yup
    //   .boolean()
    //   .oneOf([true])
    //   .required("required"),
    // Staged: yup.boolean().oneOf([true]).required("required"),
    // [`radio${rowInd}`]: yup.string().required("required"),
  });
  const {
    id,
    medic_drug_name,
    TypicalDxRx,
    AtypicalDxRx,
    Staged,
    OrphanDrug,
    OffLabel,
    ExpInvUse,
  } = row;

  const initialValues = {
    medic_drug_name: medic_drug_name ?? "",
    TypicalDxRx: TypicalDxRx ? true : false,
    AtypicalDxRx: AtypicalDxRx ? true : false,
    Staged: Staged ? true : false,
    [`radio${rowInd}`]: OrphanDrug
      ? "OrphanDrug"
      : OffLabel
      ? "OffLabel"
      : ExpInvUse
      ? "ExpInvUse"
      : "",
    // OrphanDrug: false,
    // OffLabel: false,
    // ExpInvUse: false,
  };

  const [canEdit, setCanEdit] = useState(false);
  useEffect(() => {
    setCanEdit(isBlankRow);
  }, [tableData]);

  return (
    <Formik
      key={rowInd}
      enableReinitialize
      validationSchema={tblSchema}
      onSubmit={(vals, hand) => onRowDataSubmit(vals, hand, rowInd, id)}
      initialValues={initialValues}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        setFieldValue,
      }) => (
        <tr className={step === 3 && canEdit ? "pe-auto" : "pe-none"}>
          <td
            style={
              !isBlankRow && canEdit ? { backgroundColor: "#E5E4E2" } : null
            }
          >
            <Form.Group>
              <Form.Control
                className="rounded-0 py-1"
                style={{ ...Fontstyling.label, minWidth: "70px" }}
                type="text"
                placeholder="e.g.,23"
                name="medic_drug_name"
                onChange={(e) => {
                  handleChange(e);
                }}
                value={values.medic_drug_name}
                isInvalid={touched.medic_drug_name && errors.medic_drug_name}
                maxLength={30}
                ref={inpRef}
              />
              <Form.Control.Feedback type="invalid">
                {/* {errors.medic_drug_name} */}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td
            style={
              !isBlankRow && canEdit ? { backgroundColor: "#E5E4E2" } : null
            }
          >
            <Form.Group>
              <Form.Check
                className="d-flex align-items-center justify-content-center"
                name="TypicalDxRx"
                type="checkbox"
                label=""
                onChange={(e) => {
                  handleChange(e);
                }}
                checked={values.TypicalDxRx}
                isInvalid={touched.TypicalDxRx && errors.TypicalDxRx}
              />
            </Form.Group>
          </td>
          <td
            style={
              !isBlankRow && canEdit ? { backgroundColor: "#E5E4E2" } : null
            }
          >
            <Form.Group>
              <Form.Check
                className="d-flex align-items-center justify-content-center"
                name="AtypicalDxRx"
                type="checkbox"
                label=""
                onChange={(e) => {
                  handleChange(e);
                }}
                checked={values.AtypicalDxRx}
                isInvalid={touched.AtypicalDxRx && errors.AtypicalDxRx}
              />
            </Form.Group>
          </td>
          <td
            style={
              !isBlankRow && canEdit ? { backgroundColor: "#E5E4E2" } : null
            }
          >
            <Form.Group>
              <Form.Check
                className="d-flex align-items-center justify-content-center"
                name="Staged"
                type="checkbox"
                label=""
                onChange={(e) => {
                  handleChange(e);
                }}
                checked={values.Staged}
                isInvalid={touched.Staged && errors.Staged}
              />
            </Form.Group>
          </td>
          <td
            style={
              !isBlankRow && canEdit ? { backgroundColor: "#E5E4E2" } : null
            }
          >
            <Form.Check
              className="d-flex align-items-center justify-content-center"
              type="radio"
              name={`radio${rowInd}`}
              value="OrphanDrug"
              // label=""
              onChange={(e) => {
                handleChange(e);
              }}
              checked={values[`radio${rowInd}`] === "OrphanDrug"}
              isInvalid={errors[`radio${rowInd}`] && touched[`radio${rowInd}`]}
            />
          </td>
          <td
            style={
              !isBlankRow && canEdit ? { backgroundColor: "#E5E4E2" } : null
            }
          >
            <Form.Check
              className="d-flex align-items-center justify-content-center"
              type="radio"
              name={`radio${rowInd}`}
              value="OffLabel"
              // label=""
              onChange={(e) => {
                handleChange(e);
              }}
              checked={values[`radio${rowInd}`] === "OffLabel"}
              isInvalid={errors[`radio${rowInd}`] && touched[`radio${rowInd}`]}
            />
          </td>
          <td
            style={
              !isBlankRow && canEdit ? { backgroundColor: "#E5E4E2" } : null
            }
          >
            <Form.Check
              className="d-flex align-items-center justify-content-center"
              type="radio"
              name={`radio${rowInd}`}
              value="ExpInvUse"
              // label=""
              onChange={(e) => {
                handleChange(e);
              }}
              checked={values[`radio${rowInd}`] === "ExpInvUse"}
              isInvalid={errors[`radio${rowInd}`] && touched[`radio${rowInd}`]}
            />
          </td>
          {!isPreveiw && (
            <td
              className="px-1 text-center"
              style={
                !isBlankRow && canEdit ? { backgroundColor: "#E5E4E2" } : null
              }
              xs={6}
              lg
            >
              {isBlankRow ? (
                <button
                  className="btn p-0 m-0 rounded-circle border-0"
                  id="tableform1"
                  type="submit"
                  onClick={(e) => {
                    handleSubmit(e);
                    e.preventDefault();
                  }}
                >
                  <MdAddCircle size={25} />
                </button>
              ) : (
                <div className="d-flex align-items-center justify-content-around">
                  {canEdit ? (
                    <button
                      className="btn p-0  m-0 rounded-circle border-0"
                      type="submit"
                      onClick={(e) => {
                        handleSubmit(e);
                        e.preventDefault();
                        setCanEdit(false);
                      }}
                    >
                      <IoCheckmarkCircle size={23} />
                    </button>
                  ) : (
                    <button
                      className="btn p-0 m-0 rounded-circle border-0 pe-auto"
                      type="button"
                      onClick={(e) => {
                        if (step !== 3) return;
                        setCanEdit(true);
                        e.preventDefault();
                      }}
                    >
                      <img src={editIcon} />
                    </button>
                  )}
                  <button
                    className="btn p-0 m-0 rounded-circle border-0 pe-auto"
                    type="button"
                    onClick={(e) => {
                      if (step !== 3) return;
                      onRowDelete(id);
                      // e.preventDefault();
                    }}
                  >
                    <img src={deleteIcon} width={15} />
                  </button>
                </div>
              )}
            </td>
          )}
        </tr>
      )}
    </Formik>
  );
};

const Form4TAMedTableRow = ({
  row,
  rowInd,
  tableData,
  onRowDataSubmit,
  onRowDelete,
  step,
  isPreveiw,
  stateData,
  inpRef1,
}) => {
  const isBlankRow = rowInd === tableData.length;
  const {
    id,
    TAMedName,
    State,
    ObservationCost,
    BilledMin,
    BilledMax,
    NatlMin,
    NatlMax,
  } = row;
  const tblSchema = yup.object().shape({
    TAMedName: yup
      .string()
      .required("required")
      .trim("The contact name cannot include leading and trailing spaces"),
  });

  const initialValues = {
    TAMedName: TAMedName ?? "",
    State: State ?? "",
    ObservationCost: ObservationCost ?? "",
    BilledMin: BilledMin ?? "",
    BilledMax: BilledMax ?? "",
    NatlMin: NatlMin ?? "",
    NatlMax: NatlMax ?? "",
  };
  const [canEdit, setCanEdit] = useState(false);
  useEffect(() => {
    setCanEdit(isBlankRow);
  }, [tableData]);

  return (
    <Formik
      key={rowInd}
      enableReinitialize
      validationSchema={tblSchema}
      onSubmit={(vals, hand) => onRowDataSubmit(vals, hand, id, "TAMed")}
      initialValues={initialValues}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        setFieldValue,
      }) => (
        <tr className={step === 4 && canEdit ? "pe-auto" : "pe-none"}>
          {Object.keys(initialValues).map((k_name, k_i) => {
            if (k_i === 0) {
              return (
                <td
                  key={k_i}
                  style={{
                    backgroundColor: !isBlankRow && canEdit ? "#E5E4E2" : "",
                    width: `${100 / 8}%`,
                    minWidth: `${100 / 8}%`,
                    maxWidth: `${100 / 8}%`,
                  }}
                >
                  <Form.Group>
                    <Form.Control
                      className="rounded-0 py-1 text-nowrap"
                      style={{ ...Fontstyling.label, minWidth: "70px" }}
                      type={"text"}
                      name={k_name}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      value={values[k_name]}
                      isInvalid={touched[k_name] && errors[k_name]}
                      maxLength={30}
                      ref={inpRef1}
                    />
                  </Form.Group>
                </td>
              );
            } else if (k_i === 1) {
              return (
                <td
                  key={k_i}
                  style={{
                    backgroundColor: !isBlankRow && canEdit ? "#E5E4E2" : "",
                    width: `${100 / 8}%`,
                    minWidth: `${100 / 8}%`,
                    maxWidth: `${100 / 8}%`,
                  }}
                  xs={6}
                  lg
                >
                  <Form.Group>
                    <Form.Select
                      className="rounded-0 py-1"
                      style={{
                        ...Fontstyling.label,
                        minWidth: k_i === 1 ? "110px" : "75px",
                      }}
                      name={k_name}
                      value={values[k_name]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value={""}>Select</option>
                      {stateData.map(({ state }) => (
                        <option value={state}>{state}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </td>
              );
            } else {
              return (
                <td
                  key={k_i}
                  style={{
                    backgroundColor: !isBlankRow && canEdit ? "#E5E4E2" : "",
                    width: `${100 / 8}%`,
                    minWidth: `${100 / 8}%`,
                    maxWidth: `${100 / 8}%`,
                  }}
                >
                  <Form.Group>
                    <Form.Control
                      className="rounded-0 py-1 text-nowrap"
                      style={{ ...Fontstyling.label, minWidth: "70px" }}
                      type={
                        k_name === "ObservationCost" ||
                        k_name === "BilledMin" ||
                        k_name === "BilledMax"
                          ? "number"
                          : "text"
                      }
                      name={k_name}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      value={values[k_name]}
                      maxLength={30}
                    />
                  </Form.Group>
                </td>
              );
            }
          })}
          {!isPreveiw && (
            <td
              className="px-1 text-center"
              style={
                !isBlankRow && canEdit ? { backgroundColor: "#E5E4E2" } : null
              }
              xs={6}
              lg
            >
              {isBlankRow ? (
                <button
                  className="btn p-0 m-0 rounded-circle border-0 "
                  type="submit"
                  onClick={(e) => {
                    handleSubmit(e);
                    e.preventDefault();
                  }}
                  id="tableform2"
                >
                  <MdAddCircle size={25} />
                </button>
              ) : (
                <div className="d-flex align-items-center justify-content-around">
                  {canEdit ? (
                    <button
                      className="btn p-0 m-0 rounded-circle border-0"
                      type="submit"
                      onClick={(e) => {
                        handleSubmit(e);
                        e.preventDefault();
                        setCanEdit(false);
                      }}
                    >
                      <IoCheckmarkCircle size={23} />
                    </button>
                  ) : (
                    <button
                      className="btn p-0 m-0 rounded-circle border-0 pe-auto"
                      type="button"
                      onClick={(e) => {
                        if (step !== 4) return;
                        setCanEdit(true);
                        e.preventDefault();
                      }}
                    >
                      <img src={editIcon} />
                    </button>
                  )}
                  <button
                    className="btn p-0 m-0 rounded-circle border-0 pe-auto"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      if (step !== 4) return;
                      onRowDelete(id, "TAMed");
                    }}
                  >
                    <img src={deleteIcon} width={15} />
                  </button>
                </div>
              )}
            </td>
          )}
        </tr>
      )}
    </Formik>
  );
};

const Form4TARxTableRow = ({
  row,
  rowInd,
  tableData,
  onRowDataSubmit,
  onRowDelete,
  step,
  isPreveiw,
  inpRef2,
}) => {
  const isBlankRow = rowInd === tableData.length;
  const {
    id,
    TARxName,
    MemberType,
    LineTherapy,
    QtyCostBasis,
    ObservationCost,
    AMSRiskThreshold,
    CostProjection,
    TriggerDxName,
  } = row;
  const tblSchema = yup.object().shape({
    TARxName: yup
      .string()
      .required("required")
      .trim("The contact name cannot include leading and trailing spaces"),
  });

  const initialValues = {
    TARxName: TARxName ?? "",
    MemberType: MemberType ?? "",
    LineTherapy: LineTherapy ?? "",
    QtyCostBasis: QtyCostBasis ?? "",
    ObservationCost: ObservationCost ?? "",
    AMSRiskThreshold: AMSRiskThreshold ?? "",
    CostProjection: CostProjection ?? "",
    TriggerDxName: TriggerDxName ?? "",
  };

  const [canEdit, setCanEdit] = useState(false);
  useEffect(() => {
    setCanEdit(isBlankRow);
  }, [tableData]);

  return (
    <Formik
      key={rowInd}
      enableReinitialize
      validationSchema={tblSchema}
      onSubmit={(vals, hand) => onRowDataSubmit(vals, hand, id, "TARx")}
      initialValues={initialValues}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        setFieldValue,
      }) => (
        <tr className={step === 4 && canEdit ? "pe-auto" : "pe-none"}>
          {Object.keys(initialValues).map((k_name, k_i) => {
            if (k_i === 0) {
              return (
                <td
                  key={k_i}
                  style={
                    !isBlankRow && canEdit
                      ? { backgroundColor: "#E5E4E2" }
                      : null
                  }
                  xs={6}
                  lg
                >
                  <Form.Group>
                    <Form.Control
                      className="rounded-0 py-1"
                      style={{ ...Fontstyling.label, minWidth: "70px" }}
                      type={"text"}
                      // placeholder="e.g.,23"
                      name={k_name}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      value={values[k_name]}
                      isInvalid={touched[k_name] && errors[k_name]}
                      maxLength={30}
                      ref={inpRef2}
                    />
                  </Form.Group>
                </td>
              );
            } else if (k_i === 1 || k_i === 2) {
              return (
                <td
                  key={k_i}
                  style={{
                    backgroundColor: !isBlankRow && canEdit ? "#E5E4E2" : "",
                    width: `${100 / 8}%`,
                    minWidth: `${100 / 8}%`,
                    maxWidth: `${100 / 8}%`,
                  }}
                  xs={6}
                  lg
                >
                  <Form.Group>
                    <Form.Select
                      className="rounded-0 py-1"
                      style={{
                        ...Fontstyling.label,
                        minWidth: k_i === 1 ? "110px" : "75px",
                      }}
                      name={k_name}
                      value={values[k_name]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      {k_i === 1
                        ? ["", "Adult", "Pediatric"].map((item) => (
                            <option value={item}>{item}</option>
                          ))
                        : ["", "1st", "2nd", "3rd", "4th", "NL"].map((item) => (
                            <option value={item}>{item}</option>
                          ))}
                    </Form.Select>
                  </Form.Group>
                </td>
              );
            } else {
              return (
                <td
                  key={k_i}
                  style={
                    !isBlankRow && canEdit
                      ? { backgroundColor: "#E5E4E2" }
                      : null
                  }
                  xs={6}
                  lg
                >
                  <Form.Group>
                    <Form.Control
                      className="rounded-0 py-1"
                      style={{ ...Fontstyling.label, minWidth: "70px" }}
                      type={k_name === "ObservationCost" ? "number" : "text"}
                      // placeholder="e.g.,23"
                      name={k_name}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      value={values[k_name]}
                      maxLength={30}
                    />
                  </Form.Group>
                </td>
              );
            }
          })}
          {!isPreveiw && (
            <td
              className="px-1 text-center"
              style={
                !isBlankRow && canEdit ? { backgroundColor: "#E5E4E2" } : null
              }
              xs={6}
              lg
            >
              {isBlankRow ? (
                <button
                  className="btn p-0 m-0 rounded-circle border-0"
                  type="submit"
                  id="tableform3"
                  onClick={(e) => {
                    handleSubmit(e);
                    e.preventDefault();
                  }}
                >
                  <MdAddCircle size={25} />
                </button>
              ) : (
                <div className="d-flex align-items-center justify-content-around">
                  {canEdit ? (
                    <button
                      className="btn p-0  m-0 rounded-circle border-0"
                      type="submit"
                      onClick={(e) => {
                        handleSubmit(e);
                        e.preventDefault();
                        setCanEdit(false);
                      }}
                    >
                      <IoCheckmarkCircle size={23} />
                    </button>
                  ) : (
                    <button
                      className="btn p-0  m-0 rounded-circle border-0 pe-auto"
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        if (step !== 4) return;
                        setCanEdit(true);
                      }}
                    >
                      <img src={editIcon} />
                    </button>
                  )}
                  <button
                    className="btn p-0  m-0 rounded-circle border-0 pe-auto"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      if (step !== 4) return;
                      onRowDelete(id, "TARx");
                    }}
                  >
                    <img src={deleteIcon} width={15} />
                  </button>
                </div>
              )}
            </td>
          )}
        </tr>
      )}
    </Formik>
  );
};
